import React from "react";
import { common } from "@mui/material/colors";
import { TableVirtuoso } from "react-virtuoso";
import { TableRow, Checkbox, TableCell } from "@mui/material";

import { Components } from "./components";
import { Props, ITableItem } from "./types";

const createTableItem = (data: ITableItem | string) =>
  typeof data === "string" ? { label: data } : data;

const CheckboxTable = ({
  data,
  style,
  headers,
  onSelect,
  selectedIndexes,
}: Props) => {
  const renderFixedHeaderContent = React.useCallback(() => {
    const isSelected =
      data.length === 0 ? false : data.length === selectedIndexes.length;

    return (
      <TableRow>
        <TableCell padding="checkbox" style={{ background: common.black }}>
          <Checkbox
            color="primary"
            checked={isSelected}
            onChange={() => onSelect(isSelected ? [] : data.map((_, i) => i))}
          />
        </TableCell>

        {headers.map(({ label, style, ...props }) => (
          <TableCell
            key={`checkbox-table-header-${label}`}
            style={{ background: common.black, ...style }}
            {...props}
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    );
  }, [data, selectedIndexes, onSelect, headers]);

  const renderItemContent = React.useCallback(
    (index: number, item: ITableItem[]) => {
      const isSelected = selectedIndexes.includes(index);
      const nextValue = isSelected
        ? selectedIndexes.filter((i) => i !== index)
        : [...selectedIndexes, index];

      return (
        <React.Fragment>
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              checked={isSelected}
              onChange={() => onSelect(nextValue)}
            />
          </TableCell>

          {item.map(({ label, ...props }, index) => (
            <TableCell key={`checkbox-table-item-${label}-${index}`} {...props}>
              {label}
            </TableCell>
          ))}
        </React.Fragment>
      );
    },
    [selectedIndexes, onSelect]
  );

  return (
    <TableVirtuoso
      data={data}
      components={Components}
      itemContent={renderItemContent}
      style={{ height: "600px", ...style }}
      fixedHeaderContent={renderFixedHeaderContent}
    />
  );
};

export type { ITableItem };
export { CheckboxTable, createTableItem };
